import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/common/Accordion.tsx");
